var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","fill":"currentColor"}},[(_vm.type === 'flexible')?_c('use',{attrs:{"xlink:href":"/img/sprite.svg#ic_booking-hollow"}}):_vm._e(),_vm._v(" "),(_vm.type === 'super_flexible')?_c('use',{attrs:{"xlink:href":"/img/sprite.svg#ic_booking-solid"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }